import {
    SET_LOADING,
    SEARCH_INPUT,
    SET_PAGE,
    SET_MINI_LOADING,
    GET_SINGLE_INVOICE,
    GET_INVOICES,
    INVOICE_INPUT_CHANGE,
    GET_SI_CUSTOMERS,
    GET_SI_PRODUCTS,
    GET_SI_TERMS_CONDITIONS,
    CLEAR_INVOICE,
    HANDLE_SI_SELECT_TERMS_CONDITIONS,
    HANDLE_SI_SELECT_ITEM,
    HANDLE_SI_REMOVE_ITEM,
    HANDLE_SI_ADD_ITEM,
    HANDLE_SI_SRP,
    HANDLE_SI_QTY,
    HANDLE_SI_INPUT_ATTR,
    HANDLE_SI_TOGGLE_EDIT_BTN_ATTR,
    HANDLE_SI_SELECT_CUSTOMER,
    HANDLE_SI_CHECK_VAT,
    GET_SI_TEMPLATES,
    HANDLE_SELECT_SI_TEMPLATE,
    HANDLE_SI_SELECT_TYPE_RECEIPT,
    HANDLE_SI_TOGGLE_EDIT_ROW,
    HANDLE_SI_EDIT_INPUT_ROW,
    HANDLE_SI_EDIT_UPDATE_ROW,
    HANDLE_SI_SUBMIT_ATTR,
    HANDLE_SI_SELECT_PAYMENT,
    HANDLE_SI_SELECT_PAYMENT_TYPE,
    SET_SI_ITEM_ID,
    SET_MODAL,
    HANDLE_CHECK_MANUAL,
    INVOICE_GET_SO,
    INVOICE_GET_DR,
    HANDLE_INVOICE_DATA,
    SET_DATE_PICKER,
    SORT_BY_COLUMN,
    SET_QU_ITEM_ID,
    GET_ROWS_TO_DELETE,
    SET_ROW_CHECKED,
    ITEMS_TEMPLATE,
    ADD_ITEM,
    TOGGLE_DISCOUNT_ROW,
    SET_LAST_ADDED_DROPDOWN_INDEX,
    SI_SET_CUSTOMER_DATA,
    INVOICE_CLEAR_UPLOAD,
    SI_SELECT_TAX_TYPE,
    SI_COMPUTATION_HANDLER,
    SEND_EMAIL,
    DYNAMIC_SEND_EMAIL,
    RESEND_EMAIL,
    DOWNLOAD_BTN,
    EMAIL_SETTING_DATA,
    BTN_FORM,
    GET_STATUS,
    GET_IN_STATUS,
} from './../../types';
import {
    ToastSuccess,
    ToastDanger,
    ToastWarning,
} from '../../../Services/_toast.service';
import $ from 'jquery';
import { InvoiceService } from './_service.invoice';
import {
    SwalWarning,
    SwalError,
    SwalSuccessAutoRemove,
    SwallverfiyPass,
    SwalWarningHtml,
    SwalUpdatePayment,
    SwalVerifyUpdatePayment,
} from '../../../Services/_swal.service';
import { QuotationService } from '../quotation/_service.quotation';
import { loadUnReceived } from '../receiving/receiving.actions';
import { blockRoute, setMUIPage } from '../helper/helper.actions';
import { getNumRows, getSubSetting, getUserData } from '../../../Utils/Common';
import { getSettingApp } from '../settings_app/setting_app.actions';
import { get_dr } from './../delivery/delivery.actions';

// DISCOUNT
export const handleSelectDiscountType = (selectOption) => async (dispatch) => {
    // console.log(selectOption)
    // dispatch({ type: INVOICE_INPUT_CHANGE, payload: { key: 'discount', value: 0 }})
    // dispatch({ type: INVOICE_INPUT_CHANGE, payload: { key: 'discount_type', value: selectOption.value } });

    // ** Updated select
    dispatch({
        type: INVOICE_INPUT_CHANGE,
        payload: { key: 'discount', value: 0 },
    });
    dispatch({
        type: INVOICE_INPUT_CHANGE,
        payload: { key: 'discount_type', value: selectOption },
    });
};

export const handleInputChangeDiscount = (e) => async (dispatch, getState) => {
    if (e.target.value !== '') {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { single_invoice } = getState().invoice;

    if (single_invoice.discount_type.value === 'percent') {
        if (e.target.value > 100) {
            ToastDanger(
                'If your discount is percentage, discount should not be over 100'
            );
            dispatch({
                type: INVOICE_INPUT_CHANGE,
                payload: { key: e.target.name, value: 100 },
            });
        } else if (e.target.value < 0) {
            ToastDanger('Discount should not be less than zero');
            dispatch({
                type: INVOICE_INPUT_CHANGE,
                payload: { key: e.target.name, value: 0 },
            });
        } else {
            dispatch({
                type: INVOICE_INPUT_CHANGE,
                payload: { key: e.target.name, value: e.target.value },
            });
        }
    } else {
        if (e.target.value < 0) {
            ToastDanger('Discount should not be less than zero');
            dispatch({
                type: INVOICE_INPUT_CHANGE,
                payload: { key: e.target.name, value: 0 },
            });
        } else {
            dispatch({
                type: INVOICE_INPUT_CHANGE,
                payload: { key: e.target.name, value: e.target.value },
            });
        }
    }
};

export const handleDiscountItem =
    (index, remove = false) =>
    async (dispatch, getState) => {
        let { single_invoice } = getState().invoice;
        let items = { ...single_invoice.invoice_items[index] };

        if (!items.product_name) {
            ToastDanger('Please add Product item at least one.');
            return;
        }

        if (remove) {
            items['discount'] = 0;
            items['discount_type'] = { value: 'none', label: 'None' };
            items['discount_amount'] = 0;
            items['amount'] = items.srp * items.qty;
        }

        single_invoice.invoice_items[index] = items;

        dispatch({
            type: ADD_ITEM,
            payload: single_invoice.invoice_items,
        });

        dispatch({
            type: TOGGLE_DISCOUNT_ROW,
            payload: { index, remove },
        });
    };

export const handleInputDiscountProduct =
    (e, index) => async (dispatch, getState) => {
        let { name, value } = e.target;
        value = parseFloat(value);
        let { single_invoice } = getState().invoice;
        let items = { ...single_invoice.invoice_items[index] };

        // // Save original amount if not already saved
        // if (!items.hasOwnProperty('original_amount')) {
        //   items['original_amount'] = items.srp;
        // }

        let discountedAmount = 0;
        let discountAmount = 0;

        items.amount = items.srp * items.qty;

        if (value === '0') {
        } else if (items.discount_type.value === 'percent') {
            discountAmount = (value / 100) * items.amount;
            discountedAmount = items.amount - discountAmount;
            items.amount = discountedAmount;
        } else if (items.discount_type.value === 'amount') {
            discountAmount = value;
            discountedAmount = items.amount - value;
            items.amount = discountedAmount;
        }

        items[name] = parseFloat(value);
        items['discount_amount'] = discountAmount ? discountAmount : 0;

        single_invoice.invoice_items[index] = items;
        dispatch({
            type: ADD_ITEM,
            payload: single_invoice.invoice_items,
        });
    };

export const handleSelectDiscountTypeProduct =
    (selectOption, index) => async (dispatch, getState) => {
        let { single_invoice } = getState().invoice;
        let items = { ...single_invoice.invoice_items[index] };

        // Reset discount amount when changing discount type to 'amount'
        if (selectOption.value === 'amount' || 'percent' || 'none') {
            items.discount_amount = 0;
            items.amount = items.srp * items.qty;
        }

        items.discount_type = selectOption;
        items.discount = 0;

        single_invoice.invoice_items[index] = items;
        dispatch({
            type: ADD_ITEM,
            payload: single_invoice.invoice_items,
        });
    };

export const handleChangeStatusView =
    (status_view) => async (dispatch, getState) => {
        dispatch({ type: GET_STATUS, payload: status_view });

        let { search, invoices } = getState().invoice;

        if (
            typeof invoices[status_view] === 'undefined' ||
            invoices[status_view] == null
        ) {
            dispatch({ type: SEARCH_INPUT, payload: '' });
            dispatch(getInvoices(1));
        } else {
            dispatch({
                type: SEARCH_INPUT,
                payload: invoices[status_view].search,
            });
            dispatch({
                type: GET_INVOICES,
                payload: {
                    invoices: invoices,
                    pagination: invoices[status_view],
                },
            });
        }
    };

// handle inputs
export const handleInputChange = (e) => async (dispatch) => {
    if (e.target.value !== '') {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: INVOICE_INPUT_CHANGE,
        payload: { key: e.target.name, value: e.target.value },
    });
};

// handle edit inputs
// export const handleSearchInput = e => async dispatch => dispatch({ type: SEARCH_INPUT, payload: e.target.value })
export const handleSearchInput = (e) => async (dispatch) => {
    dispatch({ type: SEARCH_INPUT, payload: e.target.value });
    // dispatch(getInvoices(1));
};

// loading
export const setLoading = (status) => async (dispatch) =>
    dispatch({ type: SET_LOADING, payload: status });
export const setMiniLoading = (status) => async (dispatch) =>
    dispatch({ type: SET_MINI_LOADING, payload: status });

// clear data
export const clearInvoice = () => async (dispatch) =>
    dispatch({ type: CLEAR_INVOICE });

// set modal
export const setPage =
    (page, id, status = true) =>
    async (dispatch, getState) => {
        let { edit_url } = getState().invoice;

        switch (page) {
            case 'main_page':
                dispatch({ type: SET_PAGE, payload: { page, status } });
                dispatch(clearInvoice());
                break;
            case 'edit_page':
                let edit_url_with_id = `${edit_url}/${id}`;
                dispatch({
                    type: SET_PAGE,
                    payload: { page, status, edit_url: edit_url_with_id },
                });
                break;
            case 'delete_modal':
                dispatch(getSingleInvoice(id, 'delete'));
                break;
            case 'print_modal_invoice':
                if (status) {
                    dispatch(getSingleInvoice(id));
                } else {
                    dispatch(invoiceClearUpload());
                }
                dispatch({ type: SET_PAGE, payload: { page, status } });
                break;
            default:
                // print_modal
                dispatch({ type: SET_PAGE, payload: { page, status } });
        }
    };

export const invoiceClearUpload = () => async (dispatch) =>
    dispatch({ type: INVOICE_CLEAR_UPLOAD });

// create selectOptions use in suppliers
const createSelectOption = (lists) => {
    let selectOptions = [];

    lists.map((val, i) => {
        let select = { value: val._id, label: val.name, i: i };

        selectOptions[i] = select;
    });

    return selectOptions;
};

export const handleSelectCustomer =
    (selectOption) => async (dispatch, getState) => {
        InvoiceService.getSingleCustomer(selectOption.value)
            .then((res) => {
                let default_customer_value = {
                    value: res.data.customer._id,
                    label: res.data.customer.name,
                };

                dispatch({
                    type: HANDLE_SI_SELECT_CUSTOMER,
                    payload: {
                        customer_id: selectOption.value,
                        customer: res.data.customer,
                        default_customer_value: default_customer_value,
                    },
                });
                let { item_template } = getState().invoice;
                let items_data = [item_template];
                dispatch({ type: ADD_ITEM, payload: items_data });
            })
            .catch((error) => {
                ToastDanger('Network error, please reload the page.');
                console.log(error);
            });
    };

// handle select payment terms
export const handleSelectTermsConditions =
    (selectOption) => async (dispatch, getState) => {
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        dispatch({
            type: HANDLE_SI_SELECT_TERMS_CONDITIONS,
            payload: selectOption,
        });

        // If the payment terms is 'none', set receipt type to 'charged sales invoice'
        let receiptType;

        if (selectOption?.value === 'none') {
            receiptType = { value: 'none', label: 'None' };
        } else {
            receiptType = {
                value: 'charged sales invoice',
                label: 'Charged Sales Invoice',
            };
        }

        dispatch(handleSelectReceiptType(receiptType));
    };

// handle selec payment type
export const handleSelectPaymentType = (selectOption) => async (dispatch) => {
    if (selectOption) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: HANDLE_SI_SELECT_PAYMENT_TYPE,
        payload: selectOption,
    });
};

// // handle select payment
// export const handleSelectPayment = selectOption => async dispatch => {
//     dispatch({ type: HANDLE_SI_SELECT_PAYMENT,payload: selectOption });
// }

// handle Select Item
export const handleSelectItem =
    (selectOption, index) => async (dispatch, getState) => {
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let { single_invoice } = getState().invoice;
        let items = { ...single_invoice.invoice_items[index] };

        // Check if the product is already selected in other rows
        const isProductAlreadySelected = single_invoice.invoice_items.some(
            (item, i) => i !== index && item.product_id === selectOption._id
        );
        if (isProductAlreadySelected) {
            // Display an error message (You can replace this with your preferred way of showing errors)
            ToastDanger('Product is already added on the list');
            // Remove the row
            dispatch(handleRemoveItem(index));
        } else if (selectOption.instock === false) {
            ToastWarning('Product is out of stock');
            // Remove the row
            dispatch(handleRemoveItem(index));
        } else {
            items['_id'] = selectOption._id;
            items['product_id'] = selectOption._id;
            items['sku'] = selectOption.sku;
            items['product_name'] = selectOption.product_name;
            items['qty'] = parseInt(selectOption.qty);
            items['product_unit_id'] = selectOption.product_unit_id;
            items['product_unit_name'] = selectOption.product_unit_name;
            items['attribute_string'] = selectOption.attribute_string;
            items['srp'] = parseFloat(selectOption.srp);
            items['unit_price'] = parseFloat(selectOption.srp); // new input field
            items['amount'] = parseFloat(selectOption.amount);
            items['status_code'] = selectOption.status_code;
            items['barcode'] = selectOption.barcode;
            items['description'] = selectOption.description;
            items['selected'] = true;
            items['brand'] = selectOption.brand;
            items['discount_type'] = { label: 'None', value: 'none' }; // default discount type
            items['discount'] = 0; // default discount
            items['discount_amount'] = 0;

            single_invoice.invoice_items[index] = items;
            dispatch({ type: ADD_ITEM, payload: single_invoice.invoice_items });
        }
    };

export const ShowComboBox = (index) => async (dispatch, getState) => {
    let { single_invoice } = getState().invoice;
    let items = { ...single_invoice.invoice_items[index] };
    items['selected'] = false;
    single_invoice.invoice_items[index] = items;
    dispatch({
        type: ADD_ITEM,
        payload: single_invoice.invoice_items,
    });
};

// handle Add Item
export const handleAddItem = (e) => async (dispatch, getState) => {
    e.preventDefault();

    if (e) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { itemSelected, single_invoice } = getState().invoice;

    const params = {
        _id: itemSelected._id,
        qty: itemSelected.qty,
        product_name: itemSelected.product_name,
    };

    const checkInStock = await dispatch(checkInStockQty(params));

    const duplicate = single_invoice.invoice_items.filter(
        (item) => item._id == itemSelected._id
    );

    if (checkInStock['error']) {
        ToastDanger(checkInStock['error']);
    } else if (itemSelected.qty == 0 || isNaN(itemSelected.qty)) {
        ToastDanger('Quantity field is required and cannot be a string value');
    } else if (itemSelected.srp == 0 || isNaN(itemSelected.srp)) {
        ToastDanger('Srp is required and cannot be a string value');
    } else if (itemSelected.product_name == '') {
        ToastDanger('Product Item is required, please select at least one');
    } else if (duplicate.length > 0) {
        ToastDanger(`${duplicate[0].product_name} is already on the list.`);
    } else {
        let invoice_items = single_invoice.invoice_items.concat(itemSelected);

        dispatch({
            type: HANDLE_SI_ADD_ITEM,
            payload: { invoice_items: invoice_items },
        });
    }
};

// Check In Stock Qty of Product
export const checkInStockQty = (params) => async (dispatch, getState) => {
    let data = [];

    try {
        const checkInstock = await InvoiceService.CheckInStock(params);
        data['status'] = checkInstock.data.status;
        data['error'] = checkInstock.data.error;
    } catch (e) {
        data['status'] = 0;
        data['error'] = e.error;
    }

    return data;
};

// Handle Remove Item
export const handleRemoveItem = (index) => async (dispatch, getState) => {
    if (index) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { invoice_items } = getState().invoice.single_invoice;
    // removing value in array base on index
    let _invoice_items = invoice_items.filter((_, i) => i !== index);

    dispatch({
        type: HANDLE_SI_REMOVE_ITEM,
        payload: { invoice_items: _invoice_items },
    });
};

// handle Srp
export const handleInputSrp = (e) => async (dispatch, getState) => {
    e.preventDefault();

    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { itemSelected } = getState().invoice;

    let srp = parseFloat(e.target.value);
    let amount = itemSelected.qty * srp;

    dispatch({ type: HANDLE_SI_SRP, payload: { srp: srp, amount: amount } });
};

// handle Qty
export const handleInputQty = (e) => async (dispatch, getState) => {
    e.preventDefault();

    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { itemSelected } = getState().invoice;
    let multipliedPrice = e.target.value * itemSelected.srp;

    dispatch({
        type: HANDLE_SI_QTY,
        payload: { qty: e.target.value, amount: parseFloat(multipliedPrice) },
    });
};

// handle discount, other
export const handleInputAttr = (e) => async (dispatch) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let name = e.target.name;
    let value = e.target.value;

    if (name == 'other') {
        dispatch({
            type: HANDLE_SI_INPUT_ATTR,
            payload: { key: e.target.name, value: parseFloat(value) },
        });
    } else {
        dispatch({
            type: HANDLE_SI_INPUT_ATTR,
            payload: { key: e.target.name, value: parseInt(value) },
        });
    }
};

// handle toggle edit discount, other
export const toggleEditBtn = (status, attr) => async (dispatch, getState) => {
    // true || false, isDiscount, isOther
    dispatch({
        type: HANDLE_SI_TOGGLE_EDIT_BTN_ATTR,
        payload: { attr: attr, status: status },
    });
};

// handle discount, other, submit
export const handleAttrSubmit = (attr) => async (dispatch, getState) => {
    let { edit_attr } = getState().invoice;
    let attr_val = edit_attr[attr];

    if (isNaN(attr_val)) {
        ToastDanger('Field required at least 0 value');
    } else {
        dispatch({
            type: HANDLE_SI_SUBMIT_ATTR,
            payload: { key: attr, value: attr_val },
        });
    }
};

// handle vat
export const handleCheckVat = (e) => async (dispatch) => {
    if (e.target.checked) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let checked;

    if (e.target.checked) {
        checked = 12;
    } else {
        checked = 0;
    }

    dispatch({ type: HANDLE_SI_CHECK_VAT, payload: checked });
};

// handle edit row
export const handleToggleEditRow = (index) => async (dispatch) => {
    dispatch({ type: HANDLE_SI_TOGGLE_EDIT_ROW, payload: index });
};

// handle input edit row
export const handleEditInputRow = (index, e) => async (dispatch, getState) => {
    e.preventDefault();

    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { edit_invoice_items } = getState().invoice;
    let name = e.target.name;
    edit_invoice_items[index][name] = parseFloat(e.target.value);

    dispatch({
        type: HANDLE_SI_EDIT_INPUT_ROW,
        payload: edit_invoice_items,
    });
};

// handle update row
export const handleUpdateRow = (index) => async (dispatch, getState) => {
    let { edit_invoice_items } = getState().invoice;

    let qty = edit_invoice_items[index].qty;
    let srp = edit_invoice_items[index].srp;

    if (qty == 0 || isNaN(qty)) {
        ToastDanger('Qty is required and cannot be a string value');
    } else if (srp == 0 || isNaN(srp)) {
        ToastDanger('Srp is required and cannot be a string value');
    } else {
        let updated_amount = srp * qty;
        edit_invoice_items[index].amount = updated_amount;

        dispatch({
            type: HANDLE_SI_EDIT_UPDATE_ROW,
            payload: edit_invoice_items,
        });
    }
};

// handle select invoice templates
export const handleSelectInvoiceTemplate =
    (selectedOption) => async (dispatch) => {
        if (selectedOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let invoice_template_id = selectedOption.value;
        let si_default_template = {
            value: selectedOption.value,
            label: selectedOption.label,
        };

        dispatch({
            type: HANDLE_SELECT_SI_TEMPLATE,
            payload: { si_default_template, invoice_template_id },
        });
    };

// handle select status [SI || DR]
export const handleSelectReceiptType =
    (selectedOption) => async (dispatch, getState) => {
        if (selectedOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        let default_select_type_receipt = {
            value: selectedOption.value,
            label: selectedOption.label,
        };

        // Check if the selected option is 'charge sales invoice' and payment terms is 'none'
        const { single_invoice } = getState().invoice;
        const payment_terms = single_invoice.payment_terms.value;

        if (
            selectedOption.value === 'charged sales invoice' &&
            payment_terms === 'none'
        ) {
            ToastDanger(
                'You cannot select charge sales invoice if payment terms is none'
            );
            selectedOption = {
                value: 'none',
                label: ' None',
            };
        } else if (
            selectedOption.value != 'charged sales invoice' &&
            payment_terms != 'none'
        ) {
            ToastDanger(
                'You cannot select different receipt type if you selected a payment terms'
            );
            selectedOption = {
                value: 'charged sales invoice',
                label: 'Charged Sales Invoice',
            };
        }

        dispatch({
            type: HANDLE_SI_SELECT_TYPE_RECEIPT,
            payload: {
                default_select_type_receipt: default_select_type_receipt,
                receipt_type: selectedOption,
            },
        });
    };

// fetch invoice templates
export const getInvoiceTemplates = (receipt_type) => async (dispatch) => {
    InvoiceService.getInvTemplates()
        .then((res) => {
            let invoice_templates = res.data.invoice_templates;

            let si_template_arr = invoice_templates.map((val) => ({
                value: val._id,
                label: val.template_name,
                name: 'invoice_template_id',
            }));

            let selected_label = '';
            if (receipt_type === 'cash') {
                selected_label = 'cash_sales_invoice';
            } else if (receipt_type === 'charged') {
                selected_label = 'charged_sales_invoice';
            }

            const matchedTemplate = invoice_templates.find(
                (template) => template.template_label === selected_label
            );

            let si_default_template = matchedTemplate
                ? {
                      value: matchedTemplate._id,
                      label: matchedTemplate.template_name,
                  }
                : {
                      value: res.data.selected_template._id,
                      label: res.data.selected_template.template_name,
                  };

            let invoice_template_id = matchedTemplate
                ? matchedTemplate._id
                : res.data.invoice_template_id;

            dispatch({
                type: GET_SI_TEMPLATES,
                payload: {
                    invoice_templates: si_template_arr,
                    si_default_template,
                    invoice_template_id,
                },
            });
        })
        .catch((error) => {
            ToastDanger('Network error, please reload the page.');
            $('.btn-remove').removeAttr('disabled').html('Remove');
            console.log(error);
        });
};

// get all the terms and conditions
export const getTermsConditions = () => async (dispatch) => {
    InvoiceService.getTermsConditions()
        .then((res) => {
            let terms_arr = [];
            let terms = res.data.terms_conditions;

            terms.map((val, i) => {
                let select = { value: val.content, label: val.title };
                terms_arr[i] = select;
            });

            terms_arr.unshift({ value: 'none', label: 'None' });

            dispatch({ type: GET_SI_TERMS_CONDITIONS, payload: terms_arr });
        })
        .catch((error) => {
            ToastDanger('Network error, please reload the page.');
            console.log(error);
        });
};

// get all the select options
export const getCustomers =
    (search = '') =>
    async (dispatch) => {
        const formdata = {
            search: search,
        };
        InvoiceService.getCustomers(formdata)
            .then((res) => {
                let customers_arr = [];
                let customers = res.data.docs;

                customers.map((val, i) => {
                    let select = {
                        value: val._id,
                        label: val.name,
                        name: 'customer_id',
                    };
                    customers_arr[i] = select;
                });

                dispatch({ type: GET_SI_CUSTOMERS, payload: customers_arr });
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    error.data.errors.map((err) => ToastDanger(err));
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                console.log(error);
            });
    };

// get all the select options
export const searchCustomers = (search) => async (dispatch) =>
    new Promise((resolve, reject) => {
        const formdata = {
            search: search,
        };
        InvoiceService.getCustomers(formdata)
            .then((res) => {
                let customers_arr = [];
                let customers = res.data.docs;

                customers.map((val, i) => {
                    let select = {
                        value: val._id,
                        label: val.name,
                        name: 'customer_id',
                    };
                    customers_arr[i] = select;
                });
                resolve(customers_arr);
                // dispatch({ type: GET_SI_CUSTOMERS, payload: customers_arr });
            })
            .catch((error) => {
                // ToastDanger('Network error, please reload the page.');
                console.log(error);
                reject(error);
            });
    });

// get the products
export const getProducts =
    (search = '') =>
    async (dispatch) => {
        const formdata = {
            search: search,
        };
        InvoiceService.getProducts(formdata)
            .then((res) => {
                let items_arr = [];
                let items = res.data.docs;

                // console.log(items)

                items.map((item, i) => {
                    // console.log("item", item);
                    let attribute = '';
                    // if(item.attribute_string === '()' || item.attribute_string === null){
                    //     attribute = '';
                    // }
                    // else{

                    //     try
                    //     {
                    //         let attr_replace_char = item.attribute_string.replace('(','').replace(')', '');
                    //         attribute = attr_replace_char.slice(0, 40) + (attr_replace_char.length > 40 ? "..." : "");
                    //     }
                    //     catch(err){
                    //         attribute = '';
                    //     }

                    // }

                    // let select = {
                    //     _id: item._id,
                    //     value: item._id,
                    //     label: item.product_name,
                    //     sub_label: attribute,
                    //     name: 'item',
                    //     product_name: item.product_name,
                    //     barcode: item.barcode,
                    //     sku: item.sku,
                    //     qty: 1,
                    //     product_unit_id: item.product_unit_id ? item.product_unit_id : '',
                    //     product_unit_name: item.product_unit !== null ? item.product_unit.name : '',
                    //     attribute_string: item.attribute_string,
                    //     srp: item.srp,
                    //     unit_price: item.srp, // this is editable new field
                    //     amount: item.srp,
                    //     description : item.description,
                    //     lot_no : item.single_lot != null && item.single_lot != undefined ? item.single_lot.lot_no : '',
                    //     status_code : item.status_code
                    // }

                    let select = {
                        _id: item._id,
                        value: item._id,
                        label: item.product_name,
                        name: 'item',
                        product_name: item.product_name,
                        barcode: item.barcode,
                        brand: item.brand,
                        sku: item.sku,
                        qty: 1,
                        instock: item.instock,
                        product_unit_name: item.product_unit || '',
                        srp: item.srp,
                        unit_price: item.srp, // this is editable new field
                        amount: item.srp,
                        description: item.description,
                    };

                    items_arr[i] = select;
                });

                dispatch({ type: GET_SI_PRODUCTS, payload: items_arr });
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    error.data.errors.map((err) => ToastDanger(err));
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                console.log(error);
            });
    };

export const searchProducst = (search, index) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        // do something was a success
        const formdata = {
            search: search,
        };
        InvoiceService.getProducts(formdata)
            .then((res) => {
                let items_arr = [];
                let items = res.data.docs;
                items.map((item, i) => {
                    let attribute = '';
                    if (
                        item.attribute_string == '()' ||
                        item.attribute_string === null
                    ) {
                        attribute = '';
                    } else {
                        try {
                            let attr_replace_char = item.attribute_string
                                .replace('(', '')
                                .replace(')', '');
                            attribute =
                                attr_replace_char.slice(0, 40) +
                                (attr_replace_char.length > 40 ? '...' : '');
                        } catch (err) {
                            attribute = '';
                        }
                    }

                    let select = {
                        _id: item._id,
                        value: item._id,
                        label: item.product_name,
                        sub_label: attribute,
                        name: 'item',
                        barcode: item.barcode,
                        brand: item.brand,
                        product_name: item.product_name,
                        sku: item.sku,
                        qty: 1,
                        instock: item.instock,
                        product_unit_name: item ? item.product_unit_name : '',
                        attribute_string: item.attribute_string,
                        srp: item.srp,
                        amount: item.srp,
                        status_code: item.status_code,
                        description: item.description,
                    };

                    //items_arr[i] = select;
                    items_arr.push(select);
                });
                resolve(items_arr);
            })
            .catch((error) => {
                ToastDanger('Network error, please reload the page.');
                console.log(error);
                reject();
            });

        // do something was a fail
    });

//  fetch
export const getInvoices =
    (pageNumber, rows_per_page = null, pageOrigin = null, date_filter = null) =>
    async (dispatch, getState) => {
        dispatch(setLoading(true));

        let {
            search,
            pagination,
            pagination_list,
            status_view,
            sort_order_name,
            sort_order_direction,
        } = getState().invoice;
        let rows_per_page_val =
            rows_per_page != null ? rows_per_page : getNumRows('invoice');

        // let params = {
        //     search: search,
        //     activePage: pagination.activePage,
        //     page: pageNumber,
        //     rows_per_page: rows_per_page_val,
        //     sort_order_name: sort_order_name,
        //     sort_order_direction: sort_order_direction
        // }

        //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
        let params = {
            search: search,
            options: {
                page: pageNumber,
                limit: rows_per_page_val || 10,
                sort_by: sort_order_name,
                sort_order: sort_order_direction,
            },
        };

        if (pageOrigin) {
            switch (pageOrigin['origin']) {
                case 'inventory_view':
                    params.product_id = pageOrigin['product_id'];
                    break;
                case 'customer_history':
                    params.customer_id = pageOrigin['customer_id'];
                default:
                    break;
            }
        }

        // Date Filtering
        if (date_filter) {
            params.date_from = date_filter['date_from'];
            params.date_to = date_filter['date_to'];
        }

        //console.log(params)

        // console.log(params);
        InvoiceService.paginateWithSearchInvoices(params, status_view)
            .then((res) => {
                let data_list = [];
                res.data.docs.map((data) => {
                    data_list.push(data);
                });

                pagination_list[status_view] = data_list;
                // let pagination = {
                //     totalCount: res.data.invoices.total,
                //     activePage: res.data.invoices.current_page,
                //     itemsCountPerPage: res.data.invoices.per_page,
                //     totalItemsCount: res.data.invoices.total
                // }

                //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
                let pagination = {
                    totalCount: res.data.total_docs,
                    activePage: res.data.page,
                    itemsCountPerPage: res.data.limit,
                    totalItemsCount: res.data.total_docs,
                };

                // let sales = [];
                // res.data.invoices.data.map((data) =>{
                //     data.sending_email = false;
                //     data.download_pdf = false;
                //     sales.push(data);
                // });

                let docs = res.data.docs;

                dispatch({
                    type: GET_IN_STATUS,
                    payload: {
                        pagination_list: pagination_list,
                        pagination: pagination,
                        invoices: docs,
                    },
                });
                dispatch(setLoading(false));
            })
            .catch((error) => {
                dispatch(setLoading(false));
                // ToastDanger('Network error, please reload the page.');
                console.log(error);
            });
    };

// get the invoice base on id
export const getSingleInvoice =
    (id, status = null) =>
    async (dispatch) => {
        dispatch(clearInvoice());
        dispatch(setMiniLoading(true));

        // InvoiceService.getSingleInvoice(id).then(res => {
        //     if(res.data.status == 1)
        //     {
        //         let single_invoice = res.data.invoice;
        //         let invoice_items = res.data.invoice.items;
        //         let si_default_template = [];
        //         let subs_setting = res.data.subs_setting;

        //         dispatch(getSettingApp());
        //         const subsetting = getSubSetting();
        //         single_invoice['default_tax'] = subsetting.tax_rate;

        //         if(single_invoice['terms'] == null){
        //             single_invoice['terms'] = subsetting.payment_terms ? subsetting.payment_terms : { value: 'none', label: 'None' };
        //         }

        //         if(single_invoice['tax'] === null){
        //             single_invoice['tax'] = 0;
        //         }

        //         if(single_invoice.receipt_type == null){
        //             single_invoice['receipt_type'] = { value: 'invoice', label: 'Sales Invoice' };
        //         }

        //         let edit_attr = {
        //             discount: res.data.invoice.discount ? res.data.invoice.discount : 0,
        //             vat: res.data.invoice.vat ? res.data.invoice.vat : 0,
        //             other:  res.data.invoice.other ? res.data.invoice.other : 0.00
        //         }

        //         let default_customer_value = { value: single_invoice.customer._id, label: single_invoice.customer.name };

        //         if(single_invoice.template_setting != null)
        //         {
        //             si_default_template = { value: single_invoice.template_setting._id, label: single_invoice.template_setting.template_name  };
        //         }

        //         let invoice_items_arr = [];
        //         // console.log("invoice_items", invoice_items);
        //         invoice_items.map(item => {
        //             let status_code = item.products ? item.products.status_code : 0;
        //             let formatted = { ...item, _invoice_item_id: item._id, status_code : status_code}
        //             invoice_items_arr.push(formatted)
        //         })

        //         single_invoice.invoice_date = single_invoice.invoice_date ? new Date(single_invoice.invoice_date) : new Date();
        //         single_invoice.subs_setting = subs_setting;
        //         single_invoice.total =  single_invoice.grand_total;

        //         dispatch({ type: GET_SINGLE_INVOICE,
        //             payload: {
        //                 single_invoice: single_invoice,
        //                 invoice_items: invoice_items_arr,
        //                 edit_attr: edit_attr,
        //                 default_customer_value: default_customer_value,
        //                 si_default_template: si_default_template,
        //                 subs_setting: res.data.subs_setting
        //             }
        //         })
        //     }

        //     if(status == 'delete')
        //     {
        //         dispatch(archive());
        //     }

        //     dispatch(setMiniLoading(false));

        // })
        // .catch(error => {
        //     dispatch(setMiniLoading(false));
        //     ToastDanger('Network error, please reload the page.');
        //     console.log(error);
        // });

        try {
            const res = await InvoiceService.getSingleInvoice(id);

            if (res.data.status === 1) {
                let single_invoice = res.data.docs;
                let invoice_items = res.data.docs.invoice_items;
                let si_default_template = [];
                let subs_setting = res.data.subs_setting;

                // console.log("GETSI", single_invoice)

                // dispatch(getSettingApp());
                // const subsetting = getSubSetting();
                // single_invoice['default_tax'] = subsetting.tax_rate;

                if (single_invoice['payment_terms'] === null) {
                    single_invoice['terms'] = single_invoice[
                        'payment_terms'
                    ] || { value: 'none', label: 'None' };
                }

                single_invoice['payment_mode'] =
                    single_invoice.payment_mode || { label: '' };

                single_invoice['payment_type'] = single_invoice.payment_mode;
                single_invoice['sales_order_no'] =
                    single_invoice.reference_no || null;
                single_invoice['sales_order_id'] =
                    single_invoice.reference_id || null;

                single_invoice['delivery_receipt_no'] =
                    single_invoice.reference_no || null;
                single_invoice['delivery_id'] =
                    single_invoice.reference_id || null;

                // if(single_invoice['tax'] === null){
                //     single_invoice['tax'] = 0;
                // }

                // if(single_invoice.receipt_type === null){
                //     single_invoice['receipt_type'] = { value: 'invoice', label: 'Sales Invoice' };
                // }

                let edit_attr = {
                    discount: single_invoice.discount
                        ? single_invoice.discount
                        : 0,
                    vat: single_invoice.vat ? single_invoice.vat : 0,
                    other: single_invoice.other ? single_invoice.other : 0.0,
                };

                let default_customer_value = {
                    value: single_invoice.customer._id,
                    label: single_invoice.customer.name,
                };

                if (single_invoice.template_setting != null) {
                    si_default_template = {
                        value: single_invoice.template_setting._id,
                        label: single_invoice.template_setting.template_name
                            ? single_invoice.template_setting.template_name
                            : single_invoice.template.template_name,
                    };
                }

                // let invoice_items_arr = [];
                // console.log("invoice_items", invoice_items);
                // invoice_items.map(item => {
                //     let status_code = item.products ? item.products.status_code : 0;
                //     let formatted = { ...item, _invoice_item_id: item._id, status_code : status_code}
                //     invoice_items_arr.push(formatted)
                // })

                single_invoice.invoice_date = single_invoice.date
                    ? new Date(single_invoice.date)
                    : new Date();
                single_invoice.total = single_invoice.total;
                // single_invoice.subs_setting = subs_setting;

                const _payload = {
                    single_invoice: single_invoice,
                    invoice_items: invoice_items,
                    edit_attr: edit_attr,
                    default_customer_value: default_customer_value,
                    si_default_template: si_default_template,
                    // subs_setting: res.data.subs_setting
                };
                //console.log( _payload )

                dispatch({ type: GET_SINGLE_INVOICE, payload: _payload });
            }

            if (status == 'delete') {
                dispatch(archive());
            }

            dispatch(setMiniLoading(false));
        } catch (error) {
            dispatch(setMiniLoading(false));
            ToastDanger('Network error, please reload the page.');
            console.log(error);
        }
    };

// handle submit form
export const handleOnSubmit =
    (method, status) => async (dispatch, getState) => {
        const { single_invoice } = getState().invoice;
        // console.log("single_invoice", single_invoice)

        // if (single_invoice.is_manual) {
        //     single_invoice.sales_order_id = null;
        // }

        let errors = [];
        single_invoice.invoice_items.map((item) => {
            if (item.qty <= 0) {
                errors.push(
                    'Quantity cannot be zero value, please add at least 1'
                );
            }
            if (item.srp <= 0) {
                errors.push(
                    'Unit Price cannot be zero value, please include at least the amount'
                );
            }
        });

        if (single_invoice.invoice_items.length == 0) {
            ToastDanger('Please add Product item at least one.');
        } else if (errors.length > 0) {
            ToastDanger(errors);
        } else {
            let stat_arr = status.split('-');
            let stat = stat_arr[0];
            let actions = stat_arr[1] !== undefined ? stat_arr[1] : null;
            // console.log("single_invoice.invoice_items", single_invoice.invoice_items);
            // console.log('SI', single_invoice);
            const data = {
                _id: single_invoice._id,
                invoice_no: single_invoice.invoice_no,
                transaction_no: single_invoice.transaction_no,
                serial_no: single_invoice.serial_no,
                reference_id: single_invoice.reference_id || null,
                reference_no: single_invoice.reference_no,
                delivery_id: single_invoice.delivery_id,
                delivery_receipt_no: single_invoice.delivery_receipt_no,
                sales_order_id: single_invoice.sales_order_id,
                sales_order_no: single_invoice.sales_order_no,
                customer: single_invoice.customer,
                customer_id: single_invoice.customer_id,
                invoice_items: single_invoice.invoice_items,
                discount: single_invoice.discount,
                discount_type: single_invoice.discount_type,
                vat_amount: single_invoice.vat_amount,
                tax: single_invoice.tax,
                tax_type: single_invoice.tax_type,
                other: single_invoice.other,
                sub_total: single_invoice.sub_total,
                total: single_invoice.total,
                total_cost: single_invoice.total_cost,
                remarks: single_invoice.remarks,
                terms_and_condition: single_invoice.terms_and_condition,
                payment_details: single_invoice.payment_details,
                internal_notes: single_invoice.internal_notes,
                payment_terms: single_invoice.payment_terms,
                payment_mode: single_invoice.payment_type,
                template_id: single_invoice.invoice_template_id,
                payment: single_invoice.payment,
                receipt_type: single_invoice.receipt_type,
                status: stat,
                invoice_date: single_invoice.invoice_date,
                reference_date: single_invoice.updated_at,
            };

            // console.log(data);
            if (single_invoice.is_manual == true) {
                data['is_manual'] = true;

                // if (data['reference_no'] === null || data['reference_no'] === '') {
                //     ToastDanger('Reference No field is required.');
                //     return; // This will exit the function and stop further execution
                // }
            } else {
                data['is_manual'] = false;
            }

            //console.log("actions", actions);
            if (method === 'create') {
                // if(status == 'draft') return dispatch(invoicePost(data));
                // if(status == 'saved') return SwalWarning('Are You Sure?','You are about to save Sales Invoice, saving this will stop you from editing any other changes. Continue?', () => dispatch(invoicePost(data)))
                // if(status == 'saved-email') return SwalWarning('Are You Sure?','You are about to save and send to email this Sales Invoice, saving this will stop you from editing any other changes. Continue?', () => dispatch(invoicePost(data, true)))

                if (status === 'draft') {
                    data['status'] = 'draft';
                    return dispatch(invoicePost(data, actions));
                }
                if (status === 'draft-print') {
                    data['status'] = 'draft_and_print';
                    return dispatch(invoicePost(data, actions));
                }
                if (status === 'draft-email') {
                    data['status'] = 'draft_and_email';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to draft and email this Sales Invoice. Continue?',
                        () => dispatch(invoicePost(data, actions))
                    );
                }
                // if(status == 'saved' || status == 'saved-print') return SwalWarning('Are You Sure?','You are about to save Sales Invoice, saving this will stop you from editing any other changes. Continue?', () => dispatch(invoicePost(data, actions)))

                if (status === 'saved') {
                    data['status'] = 'saved';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save Sales Invoice, saving this will stop you from editing any other changes. Continue?',
                        () => dispatch(invoicePost(data, actions))
                    );
                }

                if (status === 'saved-print') {
                    data['status'] = 'saved_and_print';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save Sales Invoice, saving this will stop you from editing any other changes. Continue?',
                        () => dispatch(invoicePost(data, actions))
                    );
                }

                if (status === 'saved-email') {
                    data['status'] = 'saved_and_email';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save and email this Sales Invoice, saving this will stop you from editing any other changes. Continue?',
                        () => dispatch(invoicePost(data, actions))
                    );
                }
            } else {
                // update
                // if(status == 'draft') return dispatch(updateSingleInvoice(data, data._id));
                // if(status == 'saved') return SwalWarning('Are You Sure?','You are about to save Sales Invoice, saving this will stop you from editing any other changes. Continue?', () => dispatch(updateSingleInvoice(data, data._id)))

                // if(status == 'draft' || status == 'draft-print') return dispatch(updateSingleInvoice(data, data._id, actions));

                if (status === 'draft') {
                    data['status'] = 'draft';
                    return dispatch(
                        updateSingleInvoice(data, data._id, actions)
                    );
                }

                if (status === 'draft-print') {
                    data['status'] = 'draft_and_print';
                    return dispatch(
                        updateSingleInvoice(data, data._id, actions)
                    );
                }

                if (status === 'draft-email') {
                    data['status'] = 'draft_and_email';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to draft and email this Sales Invoice. Continue?',
                        () =>
                            dispatch(
                                updateSingleInvoice(data, data._id, actions)
                            )
                    );
                }

                if (status === 'saved') {
                    data['status'] = 'saved';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save Sales Invoice, saving this will stop you from editing any other changes. Continue?',
                        () =>
                            dispatch(
                                updateSingleInvoice(data, data._id, actions)
                            )
                    );
                }

                if (status === 'saved-print') {
                    data['status'] = 'saved_and_print';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save Sales Invoice, saving this will stop you from editing any other changes. Continue?',
                        () =>
                            dispatch(
                                updateSingleInvoice(data, data._id, actions)
                            )
                    );
                }

                if (status == 'saved-email') {
                    data['status'] = 'saved_and_email';
                    return SwalWarning(
                        'Are You Sure?',
                        'You are about to save and send email this Sales Invoice, saving this will stop you from editing any other changes. Continue?',
                        () =>
                            dispatch(
                                updateSingleInvoice(data, data._id, actions)
                            )
                    );
                }

                // if(status == 'saved' || status == 'saved-print') return SwalWarning('Are You Sure?','You are about to save Sales Invoice, saving this will stop you from editing any other changes. Continue?', () => dispatch(updateSingleInvoice(data, data._id, actions)))
                // if(status == 'saved-email'){
                //     data['send_to_email'] = true;
                //     return SwalWarning('Are You Sure?','You are about to save and send email this Sales Invoice, saving this will stop you from editing any other changes. Continue?', () => dispatch(updateSingleInvoice(data, data._id, actions)))
                // }
            }
        }
    };

// store
export const invoicePost = (data, actions) => async (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setMUIPage(1));
    try {
        const res = await InvoiceService.InvoiceCreate(data);
        if (res.data.status == 0) {
            ToastDanger(res.data.errors);
        } else if (res.data.status == 1) {
            dispatch(setPage('main_page'));
            ToastSuccess(res.data.message);

            if (actions == 'print') {
                dispatch(setPage('print_modal_invoice', res.data.id));
            }
        }
        dispatch(setLoading(false));
        $('.btn-save').removeAttr('disabled').html('Save');
    } catch (error) {
        if (error.data.errors.length > 0) {
            ToastDanger(error.data.errors);
        } else {
            ToastDanger('Network error, please reload the page.');
        }
        console.log(error);
    }
};

// update
export const updateSingleInvoice = (data, id, actions) => async (dispatch) => {
    dispatch(setLoading(true));
    InvoiceService.updateSingleInvoice(data, id)
        .then((res) => {
            // switch(res.data.status){
            //     case 0:
            //         ToastDanger(res.data.errors);
            //         break;
            //     case 1:
            //         dispatch(setPage('main_page'));
            //         ToastSuccess(res.data.message);
            //         break;
            //     default:
            //         break;
            // }

            if (res.data.status == 0) {
                ToastDanger(res.data.errors);
            } else if (res.data.status == 1) {
                dispatch(setPage('main_page'));
                ToastSuccess(res.data.message);
                if (actions == 'print') {
                    dispatch(setPage('print_modal_invoice', res.data.id));
                }
            }

            dispatch(setLoading(false));
            $('.btn-save').removeAttr('disabled').html('Save');
        })
        .catch((error) => {
            if (error.data.errors.length > 0) {
                ToastDanger(error.data.errors);
            } else {
                ToastDanger('Network error, please reload the page.');
            }
            dispatch(setLoading(false));
            console.log(error);
        });
};

// archieve
export const moveToArchive =
    (pageOrigin = null) =>
    async (dispatch, getState) => {
        let { rows_to_delete } = getState().invoice;
        let id_arr = [];

        rows_to_delete.map((row) => {
            id_arr.push(row.id);
        });
        let params = { ids: JSON.stringify(id_arr) };

        InvoiceService.ArchiveInvoice(params)
            .then((res) => {
                dispatch(setRowChecked());
                switch (res.data.status) {
                    case 0:
                        ToastWarning(res.data.message);
                        if (pageOrigin !== null) {
                            if (pageOrigin['origin'] == 'customer_history') {
                                dispatch(getInvoices(1, null, pageOrigin));
                            }
                        } else {
                            dispatch(clearInvoice());
                            dispatch(getInvoices());
                        }
                        break;
                    case 1:
                        ToastSuccess(res.data.message);
                        if (pageOrigin !== null) {
                            if (pageOrigin['origin'] == 'customer_history') {
                                dispatch(getInvoices(1, null, pageOrigin));
                            }
                        } else {
                            dispatch(clearInvoice());
                            dispatch(getInvoices());
                        }
                    default:
                        break;
                }
            })
            .catch((error) => {
                if (error.data.errors.length > 0) {
                    error.data.errors.map((err) => ToastDanger(err));
                } else {
                    ToastDanger('Network error, please reload the page.');
                    console.log(error);
                }
                // ToastDanger('Network error, please reload the page.');
            });
    };

export const archive = () => async (dispatch, getState) => {
    let { single_invoice } = getState().invoice;

    SwalWarning(
        'Warning!',
        `Do you want to remove the Sales Invoice No: ${single_invoice.invoice_no}?`,
        () => dispatch(moveToArchive())
    );
};

export const setModal = (modal, status) => async (dispatch) => {
    dispatch({ type: SET_MODAL, payload: { modal: modal, status: status } });
};

// Check manual
export const handleCheckManual = (e) => async (dispatch, getState) => {
    let { invoice_items } = getState().invoice.single_invoice;
    let checked = e.target.checked;
    let invoice_items_arr = [];

    if (invoice_items.length == 0) {
        dispatch({
            type: HANDLE_CHECK_MANUAL,
            payload: {
                is_manual: checked,
                invoice_items: invoice_items_arr,
            },
        });
    } else {
        SwalWarning(
            'Warning!',
            `Selected item(s) will be overwritten, continue?`,
            () => {
                dispatch({
                    type: HANDLE_CHECK_MANUAL,
                    payload: {
                        is_manual: checked,
                        invoice_items: invoice_items_arr,
                    },
                });
            }
        );
    }
};

// Get sales_order
export const getSalesOrders = () => async (dispatch) => {
    let getParams = { use_select: true };

    InvoiceService.getSalesOrders(getParams)
        .then((res) => {
            const sales_order = res.data.docs;
            const sales_order_options = [];

            // console.log(sales_order_options)

            sales_order.map((q) => {
                let select = { value: q._id, label: q.sales_order_no };
                sales_order_options.push(select);
            });

            dispatch({ type: INVOICE_GET_SO, payload: sales_order_options });
        })
        .catch((error) => {
            // ToastDanger('Network error, please reload the page.');
            console.log(error);
        });
};

// Get delivery
export const getDeliveries = () => async (dispatch) => {
    let getParams = { use_select: true };

    InvoiceService.getDeliveries(getParams)
        .then((res) => {
            const delivery = res.data.docs;
            const delivery_options = [];

            // console.log(delivery_options)

            delivery.map((q) => {
                let select = { value: q._id, label: q.delivery_receipt_no };
                delivery_options.push(select);
            });

            dispatch({ type: INVOICE_GET_DR, payload: delivery_options });
        })
        .catch((error) => {
            // ToastDanger('Network error, please reload the page.');
            console.log(error);
        });
};

// select sales_order
export const handleSelectSalesOrder =
    (selectOption, current_invoice_id) => async (dispatch, getState) => {
        // console.log(selectOption)
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        dispatch(setMiniLoading(true));
        InvoiceService.getSingleSalesOrder(selectOption.value)
            .then((res) => {
                // console.log('RES', res.data);
                let single_sales_order = res.data.docs;
                let sales_order_items = res.data.docs.sales_order_items;

                // set the invoice template based on the receipt type
                if (
                    single_sales_order.receipt_type.value ===
                    'cash sales invoice'
                ) {
                    dispatch(getInvoiceTemplates('cash'));
                } else if (
                    single_sales_order.receipt_type.value ===
                    'charged sales invoice'
                ) {
                    dispatch(getInvoiceTemplates('charged'));
                }

                // Check if the current invoice has an id
                if (current_invoice_id) {
                    // Replace the single_sales_order id with the current invoice id
                    single_sales_order._id = current_invoice_id;
                }

                if (single_sales_order['payment_terms'] == null) {
                    single_sales_order['terms'] = {
                        value: 'none',
                        label: 'Choose Terms',
                    };
                } else {
                    single_sales_order['terms'] =
                        single_sales_order['payment_terms'];
                }

                if (single_sales_order['payment_mode'] == null) {
                    single_sales_order['payment_type'] = {
                        value: 'none',
                        label: 'None',
                    };
                } else {
                    single_sales_order['payment_type'] =
                        single_sales_order['payment_mode'];
                }

                if (single_sales_order.receipt_type == null) {
                    single_sales_order['receipt_type'] = {
                        value: 'none',
                        label: 'None',
                    };
                }

                let edit_attr = {
                    discount: single_sales_order.discount
                        ? single_sales_order.discount
                        : 0,
                    vat: single_sales_order.vat ? single_sales_order.vat : 0,
                    other: single_sales_order.other
                        ? single_sales_order.other
                        : 0.0,
                };

                let default_customer_value = {
                    value: single_sales_order.customer._id,
                    label: single_sales_order.customer.name,
                };

                let sales_order_items_arr = [];

                sales_order_items.map((item) => {
                    let formatted = {
                        ...item,
                        _invoice_item_id: item._id,
                        unit_price: item.srp,
                    };
                    sales_order_items_arr.push(formatted);
                });

                // sales_order select
                single_sales_order['reference_no'] = selectOption.label;
                single_sales_order['reference_id'] = selectOption.value;
                single_sales_order['sales_order_no'] = selectOption.label;
                single_sales_order['sales_order_id'] = selectOption.value;

                single_sales_order.status = null;

                // console.log("SINGLE", single_sales_order)

                let dataPayload = {
                    single_invoice: single_sales_order,
                    invoice_items: sales_order_items_arr,
                    edit_attr: edit_attr,
                    default_customer_value: default_customer_value,
                };

                //console.log(dataPayload)

                dispatch({
                    type: HANDLE_INVOICE_DATA,
                    payload: dataPayload,
                });
            })
            .catch((error) => {
                if (error.data?.errors.length > 0) {
                    ToastDanger(error.data.errors);
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                console.log(error);
                dispatch(setMiniLoading(false));
            });

        dispatch(setMiniLoading(false));
    };

// select delivery
export const handleSelectDelivery =
    (selectOption, current_invoice_id) => async (dispatch) => {
        // console.log(selectOption)
        if (selectOption) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        dispatch(setMiniLoading(true));
        InvoiceService.getSingleDelivery(selectOption.value)
            .then((res) => {
                // console.log(res.data)
                let single_delivery = res.data.docs;
                let delivery_items = res.data.docs.delivery_items;

                // set the invoice template based on the receipt type
                if (
                    single_delivery.receipt_type.value === 'cash sales invoice'
                ) {
                    dispatch(getInvoiceTemplates('cash'));
                } else if (
                    single_delivery.receipt_type.value ===
                    'charged sales invoice'
                ) {
                    dispatch(getInvoiceTemplates('charged'));
                }

                // Check if the current invoice has an id
                if (current_invoice_id) {
                    // Replace the single_delivery id with the current invoice id
                    single_delivery._id = current_invoice_id;
                }

                if (single_delivery['payment_terms'] == null) {
                    single_delivery['terms'] = {
                        value: 'none',
                        label: 'Choose Terms',
                    };
                } else {
                    single_delivery['terms'] = single_delivery['payment_terms'];
                }

                if (single_delivery['payment_mode'] == null) {
                    single_delivery['payment_type'] = {
                        value: 'none',
                        label: 'None',
                    };
                } else {
                    single_delivery['payment_type'] =
                        single_delivery['payment_mode'];
                }

                if (single_delivery.receipt_type == null) {
                    single_delivery['receipt_type'] = {
                        value: 'none',
                        label: 'None',
                    };
                }

                let edit_attr = {
                    discount: single_delivery.discount
                        ? single_delivery.discount
                        : 0,
                    vat: single_delivery.vat ? single_delivery.vat : 0,
                    other: single_delivery.other ? single_delivery.other : 0.0,
                };

                let default_customer_value = {
                    value: single_delivery.customer._id,
                    label: single_delivery.customer.name,
                };

                let delivery_items_arr = [];

                delivery_items.map((item) => {
                    let formatted = {
                        ...item,
                        _invoice_item_id: item._id,
                        unit_price: item.srp,
                    };
                    delivery_items_arr.push(formatted);
                });

                // delivery select
                single_delivery['reference_no'] = selectOption.label;
                single_delivery['reference_id'] = selectOption.value;
                single_delivery['delivery_receipt_no'] = selectOption.label;
                single_delivery['delivery_id'] = selectOption.value;

                single_delivery.status = null;

                let dataPayload = {
                    single_invoice: single_delivery,
                    invoice_items: delivery_items_arr,
                    edit_attr: edit_attr,
                    default_customer_value: default_customer_value,
                };

                //console.log(dataPayload)

                dispatch({
                    type: HANDLE_INVOICE_DATA,
                    payload: dataPayload,
                });
            })
            .catch((error) => {
                if (error.data?.errors.length > 0) {
                    ToastDanger(error.data.errors);
                } else {
                    ToastDanger('Network error, please reload the page.');
                }
                console.log(error);
                dispatch(setMiniLoading(false));
            });

        dispatch(setMiniLoading(false));
    };

// handle input datepicker
export const SIDatePicker = (date) => async (dispatch) => {
    if (date) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({ type: SET_DATE_PICKER, payload: date });
};

// Sort by column name and direction
export const sortTableByColumn =
    (sort_order_name, sort_order_direction, pageOrigin = null) =>
    async (dispatch) => {
        let sortingParams = {
            sort_order_name: sort_order_name,
            sort_order_direction: sort_order_direction,
        };

        dispatch({ type: SORT_BY_COLUMN, payload: sortingParams });
        dispatch(getInvoices(1, null, pageOrigin));
    };

export const handleSearchInputMUI = (e) => async (dispatch) => {
    dispatch({ type: SEARCH_INPUT, payload: e.target.value });
    // dispatch(getInvoices(1));
};

// returns selected rows only
export const getSelectedRows =
    (selectedRows, currentRows) => async (dispatch) => {
        // console.log(selectedRows, currentRows)
        let newArray = [];

        currentRows.map((current, i) => {
            selectedRows.map((selected, _i) => {
                if (selected.index == current.index) {
                    let selected = {
                        id: current.data[0],
                        name: current.data[1],
                    };
                    newArray.push(selected);
                }
            });
        });
        // console.log(newArray);
        dispatch({ type: GET_ROWS_TO_DELETE, payload: newArray });
    };

export const confirmDeleteDialogBox =
    (pageOrigin) => async (dispatch, getState) => {
        let { rows_to_delete } = getState().sales_order;
        let invoice_no = [];
        rows_to_delete.map((rows, i) => {
            invoice_no.push('<b>' + rows.name + '</b>');
        });
        SwalWarningHtml(
            'Warning!',
            `Do you want to remove the Sales Invoice(s): ${invoice_no.join(
                ', '
            )}?`,
            () => dispatch(moveToArchive(pageOrigin))
        );
    };

// set the rows unchecked
export const setRowChecked = () => async (dispatch) =>
    dispatch({ type: SET_ROW_CHECKED });

// handle prev, next page of modals
export const goPage = (direction) => async (dispatch, getState) => {
    dispatch(setMiniLoading(true));
    let {
        single_invoice: { _id },
    } = getState().invoice;

    let params = {
        direction,
        _id,
    };

    try {
        const go_to = await InvoiceService.goPage(params);
        dispatch(getSingleInvoice(go_to.data._id));
    } catch (e) {
        console.log(e);
        ToastDanger('Server Error');
        dispatch(setMiniLoading(false));
    }
};

export const add_items = () => async (dispatch, getState) => {
    let { single_invoice, item_template } = getState().invoice;
    let items_data = single_invoice.invoice_items;
    item_template.new = true;

    let errors = [];
    items_data.map((item) => {
        if (item.qty <= 0) {
            errors.push('Quantity cannot be zero value, please add at least 1');
        }
        if (item.srp <= 0) {
            errors.push(
                'Unit Price cannot be zero value, please include at least the amount'
            );
        }
    });

    if (errors.length > 0) {
        ToastDanger(errors);
    } else {
        items_data.push(item_template);
        dispatch({ type: ADD_ITEM, payload: items_data });
    }
};

export const dynamicInputChange = (e, index) => async (dispatch, getState) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { name, value } = e.target;
    let { single_invoice } = getState().invoice;
    let items = { ...single_invoice.invoice_items[index] };

    if (name == 'qty') {
        if (value <= 0) {
            value = 1;
        }
    }
    items[name] = parseFloat(value);
    // if unit_price is change srp will be disregard in the computation
    if (items.srp !== items.unit_price) {
        items.amount = parseFloat(items.qty) * parseFloat(items.unit_price);
    } else {
        items.amount = parseFloat(items.qty) * parseFloat(items.srp);
    }

    if (items.discount_type && items.discount_type.value !== 'none') {
        let discountAmount = 0;
        if (items.discount_type.value === 'percent') {
            discountAmount = (items.discount / 100) * items.amount;
        } else if (items.discount_type.value === 'amount') {
            discountAmount = items.discount;
        }
        items.amount = items.amount - discountAmount;
        items.discount_amount = discountAmount ? discountAmount : 0;
    }

    single_invoice.invoice_items[index] = items;
    dispatch({
        type: ADD_ITEM,
        payload: single_invoice.invoice_items,
    });

    let bool = false;
    // po_items.map((data, key) =>{
    //     if(data.cost <= 0 || data.srp <= 0 || data.order_qty <= 0)
    //     {
    //         bool = true;
    //     }
    // })
    // dispatch({type : BTN_SUB, payload : bool});
};

export const clear_customer = () => async (dispatch) => {
    let default_customer_value = { value: '', label: '' };
    dispatch({ type: SI_SET_CUSTOMER_DATA, payload: default_customer_value });
};

export const handleTaxType = (selectOption) => async (dispatch, getState) => {
    let { tax, default_tax } = getState().invoice.single_invoice;

    tax = selectOption.value === 'none' ? 0 : default_tax;

    dispatch({
        type: SI_SELECT_TAX_TYPE,
        payload: { tax, tax_type: selectOption },
    });
};

// COMPUTATION HANDLER
export const computationHandler = () => async (dispatch, getState) => {
    let {
        single_invoice: {
            invoice_items,
            discount,
            discount_type,
            tax,
            tax_type,
            other,
        },
    } = getState().invoice;

    discount = parseFloat(discount) || 0;
    //console.log(discount_type, discount)

    // Subtotal and discount
    const sub_total = invoice_items.reduce(
        (sub, item) => sub + parseFloat(item.amount ? item.amount : item.srp),
        0
    );
    const discounted =
        discount_type.value === 'percent'
            ? (parseFloat(sub_total) * discount) / 100
            : discount;
    const sub_total_discounted = sub_total - discounted + other;

    // Exclusive Vat     // Formula: price * (vat / 100)
    const exclusive_vat = (parseFloat(sub_total_discounted) * tax) / 100;
    //const total_w_exclusive = sub_total_discounted + ((parseFloat(sub_total_discounted) * tax) / 100) + other; // total amount
    const total_w_exclusive =
        sub_total_discounted + (parseFloat(sub_total_discounted) * tax) / 100; // total amount

    // Inclusive Vat   // Formula: price / ( (vat / 100) + 1)
    const inclusive_amount = sub_total_discounted / (tax / 100 + 1);
    const inclusive_vat = sub_total_discounted - inclusive_amount;

    let payload = {};
    switch (tax_type.value) {
        case 'exclusive':
            payload = {
                sub_total: sub_total,
                vat_amount: exclusive_vat,
                total: total_w_exclusive,
            };
            break;
        case 'inclusive':
            payload = {
                sub_total: sub_total,
                vat_amount: inclusive_vat,
                total: sub_total_discounted,
            };
            break;
        default:
            payload = {
                vat_amount: 0.0,
                sub_total: sub_total,
                total: sub_total_discounted,
            };
            break;
    }

    // console.log('COMPUTE HANDLER',payload);
    dispatch({ type: SI_COMPUTATION_HANDLER, payload });
};

export const sendEmail = (e, id) => async (dispatch, getState) => {
    let { email_config } = getState().invoice;
    if (email_config.require_password) {
        verfiyPass(function (result) {
            dispatch(sendSingleEmail(id));
        });
    } else {
        dispatch(sendSingleEmail(id));
    }
};
const sendSingleEmail = (id) => async (dispatch, getState) => {
    dispatch({ type: SEND_EMAIL, payload: true });
    let { single_invoice } = getState().invoice;
    InvoiceService.sendEmail(id)
        .then((result) => {
            ToastSuccess(result.data.message);
            dispatch({ type: SEND_EMAIL, payload: false });
            dispatch({ type: RESEND_EMAIL, payload: true });
        })
        .catch((err) => {
            if (err.data == undefined) {
                ToastDanger('Failed to send email.');
            } else {
                ToastDanger(err.data.message);
            }
            dispatch({ type: SEND_EMAIL, payload: false });
            dispatch({
                type: RESEND_EMAIL,
                payload: single_invoice.email_sent,
            });
        });
};

export const reSendEmail = (e, id) => async (dispatch, getState) => {
    SwalWarning(
        'Are you sure?',
        'Do you really want to resend this email?',
        () => dispatch(sendEmail(e, id))
    );
};

export const sendEmailDyanmic =
    (e, id, index) => async (dispatch, getState) => {
        let { invoices } = getState().invoice;
        if (invoices[index].email_sent) {
            SwalWarning(
                'Are you sure?',
                'Do you really want to resend this email?',
                () => dispatch(sendByIndex(id, index))
            );
        } else {
            dispatch(sendByIndex(id, index));
        }
    };

const sendByIndex = (id, index) => async (dispatch, getState) => {
    let { email_config } = getState().invoice;
    if (email_config.require_password) {
        verfiyPass(function (result) {
            dispatch(sendEmailIndex(id, index));
        });
    } else {
        dispatch(sendEmailIndex(id, index));
    }
};

const sendEmailIndex = (id, index) => async (dispatch, getState) => {
    let { invoices } = getState().invoice;
    let sales = invoices[index];
    sales.sending_email = true;
    invoices[index] = sales;
    dispatch({ type: DYNAMIC_SEND_EMAIL, payload: invoices });
    InvoiceService.sendEmail(id)
        .then((result) => {
            ToastSuccess(result.data.message);
            sales.sending_email = false;
            sales.email_sent = true;
            invoices[index] = sales;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: invoices });
        })
        .catch((err) => {
            // ToastDanger('Failed to send email.');
            if (err.data == undefined) {
                ToastDanger('Failed to send email.');
            } else {
                ToastDanger(err.data.message);
            }
            sales.sending_email = false;
            invoices[index] = sales;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: invoices });
        });
};

export const getPdf = (e, id, invoice_no) => async (dispatch) => {
    dispatch({ type: DOWNLOAD_BTN, payload: true });
    InvoiceService.getPdf(id)
        .then((result) => {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            let filename = invoice_no + '.pdf';
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            dispatch({ type: DOWNLOAD_BTN, payload: false });
        })

        .catch((err) => {
            dispatch({ type: DOWNLOAD_BTN, payload: false });
            try {
                ToastDanger(err.data.message);
            } catch (error) {
                ToastDanger('Failed to generate PDF.');
            }
        });
};

export const dynamiPdf = (e, id, index) => async (dispatch, getState) => {
    let { invoices } = getState().invoice;
    let sales = invoices[index];
    sales.download_pdf = true;
    invoices[index] = sales;
    dispatch({ type: DYNAMIC_SEND_EMAIL, payload: invoices });
    InvoiceService.getPdf(id)
        .then((result) => {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            let filename = sales.serial_no + '.pdf';
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();

            sales.download_pdf = false;
            invoices[index] = sales;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: invoices });
        })

        .catch((err) => {
            sales.download_pdf = false;
            invoices[index] = sales;
            dispatch({ type: DYNAMIC_SEND_EMAIL, payload: invoices });
            try {
                ToastDanger(err.data.message);
            } catch (error) {
                ToastDanger('Failed to generate PDF.');
            }
        });
};

export const emailConfig = () => async (dispatch) => {
    let x = 0;

    while (x < 3) {
        try {
            const result = await InvoiceService.getEmailConfig();
            dispatch({ type: EMAIL_SETTING_DATA, payload: result.data });
            x = 4;
        } catch (err) {
            // Temporary comment coz connection it timeout
            // ToastDanger('Failed to load email configuration.');
            console.log('error', err);
            x++;
        }
    }
};

const verfiyPass = (callback) => {
    SwallverfiyPass(function (password) {
        let formdata = {
            password: password,
            admin_email: getUserData().admin_email,
        };
        InvoiceService.verifyPassword(formdata)
            .then((result) => {
                SwalSuccessAutoRemove(result.data.message, callback('success'));
            })
            .catch((err) => {
                console.log('err', err);
                try {
                    SwalError(err.data.message);
                } catch (error) {
                    console.log('error', error);
                    SwalError('Unknown error occured');
                }
                // reject(err)
            });
    });
};

export const clickedPaymentWarning = (si) => async (dispatch) => {
    if (si.payment_status === 'paid') {
        SwalVerifyUpdatePayment('Warning!', 'Please enter passcode', () =>
            dispatch(updatePaymentStatus(si))
        );
    } else {
        await dispatch(getSettingApp());
        const subsetting = getSubSetting();

        let priceCode = ''; // initial price value
        if (subsetting.currency.currency_name != null) {
            if (subsetting.currency.code.checked === true) {
                priceCode = subsetting.currency.code.value;
            }

            if (subsetting.currency.symbol.checked === true) {
                priceCode = subsetting.currency.symbol.value;
            }
        }

        SwalUpdatePayment(
            'Warning!',
            `Are you sure you want to mark as "Paid" <br> Sales Invoice No. ${si.serial_no} with the <br> price of ${priceCode}${si.total_price} `,
            () => dispatch(updatePaymentStatus(si))
        );
    }
};

export const updatePaymentStatus = (si) => async (dispatch) => {
    let resolve = {
        message: '',
        status: 0,
    };

    try {
        const res = await InvoiceService.updatePaymentStatus(si);

        if (res.data.status === 1) {
            resolve.status = 1;
            resolve.message = res.data.message;

            dispatch(getInvoices());
        }
    } catch (err) {
        console.log(err);
        ToastDanger('Server Error');
    }

    return resolve;
};

export const cancelSi = () => async (dispatch, getState) => {
    let { single_invoice } = getState().invoice;
    // console.log("single_invoice", single_invoice);
    SwalWarningHtml(
        'Are You Sure?',
        'You are about to cancel Sales Invoice <b>' +
            single_invoice.serial_no +
            '</b>. Continue?',
        () => dispatch(passwordCancel())
    );
};

const passwordCancel = () => async (dispatch) => {
    SwallverfiyPass(function (password) {
        let formdata = {
            password: password,
            admin_email: getUserData().admin_email,
            role_id: getUserData().role_id,
            subscriber_id: getUserData().subscriber_id,
            id: getUserData()._id,
        };
        InvoiceService.verifyPassword(formdata)
            .then((result) => {
                SwalSuccessAutoRemove(
                    result.data.message,
                    dispatch(submitCancel())
                );
            })
            .catch((err) => {
                console.log('err', err);
                try {
                    SwalError(err.data.message);
                } catch (error) {
                    console.log('error', error);
                    SwalError('Unknown error occured');
                }
                // reject(err)
            });
    });
};

export const submitCancel = () => async (dispatch, getState) => {
    let { single_invoice, btn_form } = getState().invoice;
    btn_form.cancel = true;
    dispatch({ type: BTN_FORM, payload: btn_form });
    InvoiceService.cancelInvoice(single_invoice._id)
        .then((result) => {
            btn_form.cancel = false;
            dispatch({ type: BTN_FORM, payload: btn_form });
            ToastSuccess(
                'Sales Invoice: ' + single_invoice.serial_no + ' cancelled'
            );
            dispatch(setPage('main_page'));
        })
        .catch((err) => {
            btn_form.cancel = false;
            dispatch({ type: BTN_FORM, payload: btn_form });
            try {
                ToastDanger(err.data.message);
            } catch (err) {
                ToastDanger('Failed to cancel Sales Invoice');
            }
        });
};

export const getInternalNotesText = (notes) => {
    if (!notes) return '';

    // Case 1: already a plain string
    if (typeof notes === 'string') {
        return notes;
    }

    // Case 2: array (our normalized backend format)
    if (Array.isArray(notes)) {
        if (notes.length === 0) return '';

        const first = notes[0];

        // [{ message: 'for approval', ... }]
        if (first && typeof first.message === 'string') {
            return first.message;
        }

        // Old nested shape:
        // [{ message: [ { message: 'for approval', ... } ], ... }]
        if (first && Array.isArray(first.message) && first.message.length > 0) {
            const inner = first.message[0];
            if (typeof inner === 'string') return inner;
            if (inner && typeof inner.message === 'string') {
                return inner.message;
            }
        }

        // Fallback if items are strings
        if (typeof first === 'string') {
            return first;
        }

        return '';
    }

    // Case 3: single object { message: '...' }
    if (typeof notes === 'object' && typeof notes.message === 'string') {
        return notes.message;
    }

    return '';
};
